import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function Customers() {
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');
    const [selected, setSelected] = useState(null);

    useEffect(() => {
        axios.get('/api/customers')
            .then(r => setCustomers(r.data))
            .catch(() => setCustomers([]))
            .finally(() => setLoading(false));
    }, []);

    const addCustomer = async () => {
        const name    = prompt('Customer Name:');
        const company = prompt('Company Name:');
        const email   = prompt('Email:');
        const phone   = prompt('Phone:');
        const gstin   = prompt('GSTIN (optional):') || '';
        if (name && email) {
            try {
                const res = await axios.post('/api/customers', { name, company, email, phone, gstin, status: 'Active' });
                setCustomers(prev => [...prev, res.data.customer]);
            } catch { alert('Failed to add customer'); }
        }
    };

    const deleteCustomer = async (id) => {
        if (!window.confirm('Delete this customer?')) return;
        try {
            await axios.delete(`/api/customers/${id}`);
            setCustomers(prev => prev.filter(c => c.id !== id));
        } catch { alert('Delete failed'); }
    };

    const toggleStatus = async (c) => {
        const newStatus = c.status === 'Active' ? 'Inactive' : 'Active';
        try {
            await axios.put(`/api/customers/${c.id}`, { status: newStatus });
            setCustomers(prev => prev.map(x => x.id === c.id ? { ...x, status: newStatus } : x));
        } catch { alert('Update failed'); }
    };

    const filtered = customers.filter(c =>
        c.name.toLowerCase().includes(search.toLowerCase()) ||
        c.email.toLowerCase().includes(search.toLowerCase()) ||
        (c.company || '').toLowerCase().includes(search.toLowerCase())
    );

    return (
        <>
            <style>{`
                .cust-row { transition: background 0.15s ease, transform 0.15s ease; cursor:pointer; }
                .cust-row:hover { background:#f8fafc !important; }
                .cust-btn { display:inline-flex; align-items:center; gap:7px; padding:9px 18px; border-radius:9px; border:none; font-family:'Inter',sans-serif; font-weight:600; font-size:13px; cursor:pointer; transition:all 0.2s ease; }
                .cust-btn:hover { transform:translateY(-2px); }
                .cust-btn:active { transform:scale(0.97); }
                .search-box { padding:10px 14px 10px 38px; border-radius:9px; border:1.5px solid #e2e8f0; font-size:14px; font-family:'Inter',sans-serif; outline:none; transition:all 0.2s ease; width:260px; background:#f8fafc; }
                .search-box:focus { border-color:#3b82f6; background-color:#fff; box-shadow:0 0 0 3px rgba(59,130,246,0.12); }
                .badge { padding:3px 10px; border-radius:20px; font-size:11px; font-weight:700; }
            `}</style>

            <div style={{ background:'#fff', borderRadius:'16px', boxShadow:'0 4px 24px -8px rgba(0,0,0,0.08)', border:'1px solid #f1f5f9', overflow:'hidden' }}>
                {/* Header */}
                <div style={{ padding:'24px 28px', borderBottom:'1px solid #f1f5f9', display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:'14px' }}>
                    <div>
                        <h2 style={{ margin:0, fontSize:'20px', fontWeight:'800', color:'#0f172a' }}>👥 Customers</h2>
                        <p style={{ margin:'4px 0 0', fontSize:'13px', color:'#94a3b8' }}>{customers.length} total clients • Live from backend</p>
                    </div>
                    <div style={{ display:'flex', gap:'10px', alignItems:'center', flexWrap:'wrap' }}>
                        <div style={{ position:'relative' }}>
                            <span style={{ position:'absolute', left:'12px', top:'50%', transform:'translateY(-50%)', color:'#94a3b8' }}>🔍</span>
                            <input className="search-box" placeholder="Search customers…" value={search} onChange={e => setSearch(e.target.value)} />
                        </div>
                        <button className="cust-btn" style={{ background:'#f1f5f9', color:'#475569' }} onClick={() => setSearch('')}>🔄 Reset</button>
                        <button className="cust-btn" style={{ background:'linear-gradient(135deg,#3b82f6,#2563eb)', color:'white', boxShadow:'0 4px 12px rgba(59,130,246,0.3)' }} onClick={addCustomer}>＋ New Customer</button>
                    </div>
                </div>

                {/* Stats bar */}
                <div style={{ display:'flex', borderBottom:'1px solid #f1f5f9' }}>
                    {[['Total', customers.length, '#3b82f6'], ['Active', customers.filter(c=>c.status==='Active').length, '#10b981'], ['Inactive', customers.filter(c=>c.status!=='Active').length, '#f59e0b']].map(([l,v,c]) => (
                        <div key={l} style={{ flex:1, padding:'14px 24px', borderRight:'1px solid #f1f5f9', textAlign:'center' }}>
                            <div style={{ fontSize:'22px', fontWeight:'800', color:c }}>{v}</div>
                            <div style={{ fontSize:'12px', color:'#94a3b8', fontWeight:'600', marginTop:'2px' }}>{l}</div>
                        </div>
                    ))}
                </div>

                {loading ? (
                    <div style={{ padding:'60px', textAlign:'center', color:'#94a3b8' }}>⏳ Loading customers from server…</div>
                ) : (
                <div style={{ overflowX:'auto' }}>
                    <table style={{ width:'100%', borderCollapse:'collapse' }}>
                        <thead>
                            <tr style={{ background:'#f8fafc' }}>
                                {['Name','Company','Email','Phone','GSTIN','Status','Actions'].map(h => (
                                    <th key={h} style={{ padding:'13px 20px', textAlign:'left', fontSize:'11px', fontWeight:'800', color:'#64748b', textTransform:'uppercase', letterSpacing:'1px', whiteSpace:'nowrap' }}>{h}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.length === 0 && (
                                <tr><td colSpan={7} style={{ padding:'40px', textAlign:'center', color:'#94a3b8', fontSize:'15px' }}>
                                    😕 No customers found.
                                    <button className="cust-btn" style={{ background:'#eff6ff', color:'#3b82f6', marginLeft:'10px' }} onClick={addCustomer}>+ Add First Customer</button>
                                </td></tr>
                            )}
                            {filtered.map(c => (
                                <tr key={c.id} className="cust-row" style={{ borderBottom:'1px solid #f1f5f9', background:'#fff' }} onClick={() => setSelected(selected === c.id ? null : c.id)}>
                                    <td style={{ padding:'14px 20px' }}>
                                        <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
                                            <div style={{ width:'34px', height:'34px', borderRadius:'50%', background:`hsl(${(c.name||'').charCodeAt(0)*13%360},60%,55%)`, color:'white', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:'700', fontSize:'14px', flexShrink:0 }}>{(c.name||'?').charAt(0).toUpperCase()}</div>
                                            <span style={{ fontWeight:'600', color:'#1e293b', fontSize:'14px' }}>{c.name}</span>
                                        </div>
                                    </td>
                                    <td style={{ padding:'14px 20px', fontSize:'14px', color:'#475569' }}>{c.company || '—'}</td>
                                    <td style={{ padding:'14px 20px', fontSize:'14px', color:'#3b82f6' }}>{c.email}</td>
                                    <td style={{ padding:'14px 20px', fontSize:'14px', color:'#475569' }}>{c.phone || '—'}</td>
                                    <td style={{ padding:'14px 20px', fontSize:'12px', color:'#475569', fontFamily:'monospace' }}>{c.gstin || '—'}</td>
                                    <td style={{ padding:'14px 20px' }}>
                                        <span className="badge" style={{ background: c.status === 'Active' ? '#dcfce7' : '#fef9c3', color: c.status === 'Active' ? '#16a34a' : '#ca8a04', cursor:'pointer' }}
                                            onClick={e => { e.stopPropagation(); toggleStatus(c); }}>{c.status}</span>
                                    </td>
                                    <td style={{ padding:'14px 20px' }}>
                                        <div style={{ display:'flex', gap:'6px' }}>
                                            <button className="cust-btn" style={{ padding:'6px 12px', background:'#eff6ff', color:'#2563eb', fontSize:'12px' }} onClick={e => { e.stopPropagation(); alert(`${c.name}\n${c.company}\n${c.email}\n${c.phone}\nGSTIN: ${c.gstin || 'N/A'}`); }}>👁️ View</button>
                                            <button className="cust-btn" style={{ padding:'6px 12px', background:'#f0fdf4', color:'#16a34a', fontSize:'12px' }} onClick={e => { e.stopPropagation(); alert(`Sending invoice to ${c.email}`); }}>🧾 Invoice</button>
                                            <button className="cust-btn" style={{ padding:'6px 12px', background:'#fef2f2', color:'#dc2626', fontSize:'12px' }} onClick={e => { e.stopPropagation(); deleteCustomer(c.id); }}>🗑️ Delete</button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                )}

                {/* Footer */}
                <div style={{ padding:'14px 24px', borderTop:'1px solid #f1f5f9', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                    <span style={{ fontSize:'13px', color:'#94a3b8' }}>Showing {filtered.length} of {customers.length} customers • Live from backend</span>
                    <button className="cust-btn" style={{ background:'#f1f5f9', color:'#475569', fontSize:'13px' }} onClick={addCustomer}>＋ Add Customer</button>
                </div>
            </div>
        </>
    );
}